import { getMissingConditionsContent } from './missingConditions';

const SHOW_WHEN_PREVIOUS_FACILITATOR = {
  id: 'info_facilitator_questions_0',
  value: 'Sí',
};
const SHOW_WHEN_NEW_TRAINEE = {
  id: 'info_facilitator_questions_0',
  value: 'No',
};

export const newLeadersRequirementLists = {
  Grupo_de_Discipulado: {
    text: `Para ser líder de grupo de discipulado es necesario: \n 1.  Asistir activamente en un grupo de discipulado como mínimo hace 6 meses. \n 2. Tener el aval de tu líder. \n 3. Haber realizado los pasos de crecer incluyendo Influencia. \n 4. Realizar el proceso de Entrevista.  \n 5. Si deseas ser líder de un grupo de generaciones ( 7 a 9 años, 10 a 13 años, o 14 a 17 años) debes estar sirviendo en experiencia en algún área de generaciones como mínimo hace 6 meses.`,
    type: 'richText',
    textOnlyInQuestions: true,
  },
  Couple_Seminaries: {
    text: `Para ser facilitador en entrenamiento es necesario: \n \n 1. Haber recibido el seminario completo. \n 2. Asistir activamente en un grupo de discipulado como mínimo hace 6 meses. \n 3. Tener el aval de tu líder de grupo. \n 4. Haber realizado los pasos de crecer hasta vida. \n 5. Estar casados.`,
    type: 'richText',
    textOnlyInQuestions: true,
    showWhen: SHOW_WHEN_NEW_TRAINEE,
  },
  Relaciones_Sanas: {
    text: `Para ser facilitador en entrenamiento es necesario: \n \n 1. Haber recibido el seminario completo. \n 2. Asistir activamente en un grupo de discipulado como mínimo hace 6 meses.  \n 3. Tener el aval de tu líder de grupo. \n 4. Haber realizado los pasos de crecer hasta influencia o estar realizando influencia en el momento.`,
    type: 'richText',
    textOnlyInQuestions: true,
    showWhen: SHOW_WHEN_NEW_TRAINEE,
  },
  Transformacion_Empresarial: {
    text: `Para ser facilitador en entrenamiento es necesario:  \n \n 1. Haber recibido el seminario completo. \n 2. Asistir activamente en un grupo de discipulado como mínimo hace 6 meses. \n 3. Tener el aval de tu líder de grupo. \n 4. Haber realizado los pasos de crecer hasta vida.`,
    type: 'richText',
    textOnlyInQuestions: true,
    showWhen: SHOW_WHEN_NEW_TRAINEE,
  },
  Escuela_de_Heroes: {
    text: `Para ser facilitador en entrenamiento es necesario:  \n \n 1. Haber recibido el seminario completo. \n 2. Asistir activamente en un grupo de discipulado como mínimo hace 6 meses. \n 3. Tener el aval de tu líder de grupo. \n 4. Haber realizado los pasos de crecer hasta vida.`,
    type: 'richText',
    textOnlyInQuestions: true,
    showWhen: SHOW_WHEN_NEW_TRAINEE,
  },
  Ruta_128: {
    text: `Para ser facilitador en entrenamiento es necesario:  \n \n 1. Haber recibido el seminario completo. \n 2. Asistir activamente en un grupo de discipulado como mínimo hace 6 meses. \n 3. Tener el aval de tu líder de grupo. \n 4. Haber realizado los pasos de crecer hasta vida.`,
    type: 'richText',
    textOnlyInQuestions: true,
    showWhen: SHOW_WHEN_NEW_TRAINEE,
  },
  Entrenador_de_Equipo: {
    text: `Para ser entrenador de un equipo de Líderes, es necesario: \n \n 1. Tener como mínimo 1 líder que lleva discipulando entre 4 a 6 meses. \n 2. Debe haber realizado todos los procesos de Crecer. \n 3. Tiene un nivel de madurez espiritual, en carácter y en discipulado. \n 4. Está conectado con la visión de comunidad de formar a otros discipuladores. \n 5. Tiene el aval de su líder. `,
    type: 'richText',
    textOnlyInQuestions: true,
  },
};

export const wellnessQuestions = (gender = '') => [
  {
    text: 'Área emocional y espiritual',
    type: 'title',
    textOnlyInQuestions: true,
  },
  {
    text: '¿Reconoces estabilidad emocional y madurez espiritual en esta etapa de tu vida?',
    type: 'select',
    options: ['Sí', 'No'],
    id: `wellness_${gender}_questions_0`,
  },
  {
    text: '¿Consideras que hoy puedes escuchar, acompañar y servir a otros desde una vida emocional sana?',
    type: 'select',
    options: ['Sí', 'No'],
    id: `wellness_${gender}_questions_1`,
  },
  {
    text: '¿Hay heridas emocionales, situaciones personales o conflictos internos que actualmente necesiten atención o acompañamiento?',
    type: 'select',
    options: ['Sí', 'No'],
    id: `wellness_${gender}_questions_2`,
  },
  {
    text: '¿Asistes fielmente a tu grupo de discipulado?',
    type: 'select',
    options: ['Sí', 'No'],
    id: `wellness_${gender}_questions_3`,
  },
  {
    text: 'Área relacional',
    type: 'title',
    textOnlyInQuestions: true,
  },
  {
    text: '¿Consideras que actualmente estás viviendo relaciones sanas y estables con las personas cercanas a tu vida?',
    type: 'select',
    options: ['Sí', 'No'],
    id: `wellness_${gender}_questions_4`,
  },
  {
    text: '¿Hay conflictos importantes sin resolver en tu familia, liderazgo, discipulado o relaciones cercanas?',
    type: 'select',
    options: ['Sí', 'No'],
    id: `wellness_${gender}_questions_5`,
  },
  {
    text: '¿Cómo describirías hoy tu relación con tu líder de grupo?',
    type: 'select',
    options: [
      'Cercana — hay confianza y comunicación abierta.',
      'Respetuosa, aunque aún estamos creciendo en cercanía.',
      'Distante o con tensiones sin resolver.',
    ],
    id: `wellness_${gender}_questions_6`,
  },
  {
    text: '¿Tienes disposición para recibir guía, corrección y acompañamiento?',
    type: 'select',
    options: ['Sí', 'No'],
    id: `wellness_${gender}_questions_7`,
  },
  {
    text: 'Área sexual e integridad',
    type: 'title',
    textOnlyInQuestions: true,
  },
  {
    text: '¿Consideras que actualmente estás viviendo sanidad e integridad en el área sexual?',
    type: 'select',
    options: ['Sí', 'No'],
    id: `wellness_${gender}_questions_8`,
  },
  {
    text: '¿Hay luchas, hábitos o situaciones en esta área que actualmente necesiten acompañamiento?',
    type: 'select',
    options: ['Sí', 'No'],
    id: `wellness_${gender}_questions_9`,
  },
  {
    text: 'Acompañamiento y consejería',
    type: 'title',
    textOnlyInQuestions: true,
  },
  {
    text: '¿Estás recibiendo actualmente acompañamiento o consejería enfocada en alguna de estas áreas específicas?',
    type: 'checkbox',
    multiple: true,
    optional: true,
    class: 'wellness-areas-checkbox',
    options: ['Emocional', 'Relacional', 'Sexual', 'Familiar', 'Espiritual'],
    id: `wellness_${gender}_questions_10`,
  },
  {
    text: 'Si marcaste alguna área, ¿cómo describirías ese acompañamiento?',
    type: 'checkbox',
    radio: true,
    class: 'wellness-counseling-radio',
    requiredWhenFilled: `wellness_${gender}_questions_10`,
    options: [
      'Es un proceso intencionado con mi líder enfocado específicamente en esa área',
      'Es el discipulado y orientación bíblica general que recibo en mi grupo, no un proceso enfocado en un área específica',
      'Es con un consejero o profesional externo a la iglesia',
    ],
    id: `wellness_${gender}_questions_11`,
  },
  {
    text: 'Servicio y disposición',
    type: 'title',
    textOnlyInQuestions: true,
  },
  {
    text: '¿Consideras que este es un buen momento de tu vida para servir acompañando personas?',
    type: 'select',
    options: ['Sí', 'No'],
    id: `wellness_${gender}_questions_12`,
  },
  {
    text: '¿Tu deseo de servir nace del amor por Dios y por las personas?',
    type: 'select',
    options: ['Sí', 'No'],
    id: `wellness_${gender}_questions_13`,
  },
  {
    text: '¿Hay alguna situación personal que consideres importante compartir antes de iniciar este proceso?',
    type: 'textArea',
    optional: true,
    id: `wellness_${gender}_questions_14`,
  },
];

export const newLeadersQuestions = {
  Grupo_de_Discipulado: [
    [
      {
        text: 'Solicitud para ser Líder de Grupo de Discipulado',
        type: 'title',
      },
      newLeadersRequirementLists?.Grupo_de_Discipulado,
      {
        text: 'Siendo así, te invitamos a diligenciar las siguientes preguntas para validar los requisitos y guiarte en el proceso.',
        type: 'text',
        textOnlyInQuestions: true,
      },
      {
        text: '¿Asistes activamente en un grupo de discipulado como mínimo hace 6 meses?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_0',
      },
      {
        text: '¿Has realizado los pasos de CRECER incluyendo INFLUENCIA?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_1',
      },
      {
        text: '¿Tienes el aval del líder para abrir un grupo de discipulado?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_2',
      },
      {
        type: 'nextButton',
      },
    ],
    [
      {
        text: 'Solicitud para ser Líder de Grupo de Discipulado',
        type: 'title',
        textOnlyInQuestions: true,
      },
      {
        text: 'Llena tu información',
        type: 'form',
        textOnlyInQuestions: true,
      },
      {
        text: 'Nombre de tu líder',
        type: 'input',
        id: 'personal_leader_name',
      },
      {
        text: 'Teléfono de tu líder',
        type: 'input',
        kind: 'number',
        id: 'personal_leader_phone',
      },
      {
        text: 'Estado civil',
        type: 'select',
        options: ['Casado/a', 'Soltero/a', 'Union Libre', 'Viudo/a', 'Separado/a'],
        id: 'personal_civil_status',
      },
      {
        type: 'prevButton',
      },
      {
        type: 'nextButton',
      },
    ],
    [
      {
        text: 'Solicitud para ser Líder de Grupo de Discipulado',
        type: 'title',
        textOnlyInQuestions: true,
      },
      newLeadersRequirementLists?.Grupo_de_Discipulado,
      {
        text: 'Si cumples con estos puntos te invitamos a esperar la entrevista realizada por el equipo de discipulado y luego recibir la capacitación para líderes nuevos.',
        type: 'text',
        textOnlyInQuestions: true,
      },
      {
        text: 'Nota: No abrir grupo de discipulado sin tener todo el proceso completo.',
        type: 'text',
        textOnlyInQuestions: true,
      },
      {
        type: 'habeasData',
      },
      {
        type: 'prevButton',
      },
      {
        type: 'send',
      },
    ],
  ],
  Couple_Seminaries: [
    [
      {
        text: 'Facilitadores seminario Para Siempre y Proyecto Matrimonio',
        type: 'title',
      },
      {
        text: '¿Fuiste facilitador en el ciclo pasado?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'info_facilitator_questions_0',
      },
      {
        type: 'nextButton',
      },
    ],
    [
      {
        text: 'Facilitadores en entrenamiento seminario Para Siempre y Proyecto Matrimonio',
        type: 'title',
      },
      newLeadersRequirementLists?.Couple_Seminaries,
      {
        text: 'Siendo así, te invitamos a diligenciar las siguientes preguntas para validar los requisitos y guiarte en el proceso.',
        type: 'text',
        textOnlyInQuestions: true,
        showWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Están Casados?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_are_married',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Asisten activamente en un grupo de discipulado como mínimo hace 6 meses?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_0',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Tienen el aval del líder del grupo de discipulado?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_1',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿El terminó CRECER hasta el paso VIDA?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_2',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Ella terminó CRECER hasta el paso VIDA?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_3',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Cuales seminarios completaron completamente?',
        type: 'select',
        options: [
          'Si, terminamos el seminario Para Siempre',
          'Si, terminamos el seminario Proyecto Matrimonio',
          'Si, terminamos ambos seminarios',
          'No',
        ],
        id: 'conditional_questions_4',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Eres líder de un grupo de discipulado?',
        type: 'select',
        options: ['Si', 'No'],
        id: 'conditional_questions_5',
        conditionalRequiredWhen: SHOW_WHEN_PREVIOUS_FACILITATOR,
      },
      {
        type: 'nextButton',
      },
    ],
    [
      {
        text: 'Facilitadores seminario Para Siempre y Proyecto Matrimonio',
        type: 'title',
        textOnlyInQuestions: true,
      },
      {
        text: 'Preguntas de él',
        type: 'title',
      },
      ...wellnessQuestions('his'),
      {
        type: 'prevButton',
      },
      {
        type: 'nextButton',
      },
    ],
    [
      {
        text: 'Facilitadores seminario Para Siempre y Proyecto Matrimonio',
        type: 'title',
        textOnlyInQuestions: true,
      },
      {
        text: 'Preguntas de ella',
        type: 'title',
      },
      ...wellnessQuestions('her'),
      {
        type: 'prevButton',
      },
      {
        type: 'nextButton',
      },
    ],
    [
      {
        text: 'Facilitadores seminario Para Siempre y Proyecto Matrimonio',
        type: 'title',
        textOnlyInQuestions: true,
      },
      {
        text: 'Llena la información de él',
        type: 'form_male',
        textOnlyInQuestions: true,
      },
      {
        text: 'Nombre del líder de él',
        type: 'input',
        id: 'personal_his_leader_name',
      },
      {
        text: 'Teléfono del líder de él',
        type: 'input',
        kind: 'number',
        id: 'personal_his_leader_phone',
      },
      {
        text: 'Llena la información de ella',
        type: 'form_female',
        textOnlyInQuestions: true,
      },
      {
        text: 'Nombre del líder de ella',
        type: 'input',
        id: 'personal_her_leader_name',
      },
      {
        text: 'Teléfono del líder de ella',
        type: 'input',
        kind: 'number',
        id: 'personal_her_leader_phone',
      },
      {
        text: 'Nombre de la última pareja de facilitadores del seminario',
        type: 'input',
        id: 'info_last_facilitator_couple_name',
        optionalWhen: { id: 'info_facilitator_questions_0', value: 'No' },
      },
      {
        text: 'Celular de la última pareja de facilitadores del seminario',
        type: 'input',
        kind: 'number',
        id: 'info_last_facilitator_couple_phone',
        optionalWhen: { id: 'info_facilitator_questions_0', value: 'No' },
      },
      {
        text: '¿En cuál seminario desean ser facilitadores?',
        type: 'select',
        options: ['Para Siempre', 'Proyecto Matrimonio'],
        id: 'info_couple_seminary',
      },
      {
        type: 'habeasData',
      },
      {
        type: 'prevButton',
      },
      {
        type: 'send',
      },
    ],
  ],
  Relaciones_Sanas: [
    [
      {
        text: 'Facilitador seminario "Relaciones sanas"',
        type: 'title',
      },
      {
        text: '¿Fuiste facilitador en el ciclo pasado?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'info_facilitator_questions_0',
      },
      {
        type: 'nextButton',
      },
    ],
    [
      {
        text: 'Facilitadores en entrenamiento seminario Relaciones Sanas',
        type: 'title',
      },
      newLeadersRequirementLists.Relaciones_Sanas,
      {
        text: 'Siendo así, te invitamos a diligenciar las siguientes preguntas para validar los requisitos y guiarte en el proceso.',
        type: 'text',
        textOnlyInQuestions: true,
        showWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Asistes activamente en un grupo de discipulado como mínimo hace 6 meses?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_0',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Tienes el aval del líder para abrir un grupo de discipulado?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_1',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Has realizado hasta el paso de crecer Influencia?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_2',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Has realizado el seminario de Relaciones Sanas?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_3',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Eres líder de un grupo de discipulado?',
        type: 'select',
        options: ['Si', 'No'],
        id: 'conditional_questions_4',
      },
      {
        type: 'nextButton',
      },
    ],
    [
      {
        text: 'Facilitador seminario "Relaciones sanas"',
        type: 'title',
        textOnlyInQuestions: true,
      },
      {
        text: 'Preguntas personales',
        type: 'title',
      },
      ...wellnessQuestions(),
      {
        type: 'prevButton',
      },
      {
        type: 'nextButton',
      },
    ],
    [
      {
        text: 'Facilitador "Relaciones sanas"',
        type: 'title',
        textOnlyInQuestions: true,
      },
      {
        text: 'Llena tu información',
        type: 'form',
        textOnlyInQuestions: true,
      },
      {
        text: '¿Eres líder de grupo de discipulado?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'info_has_been_leader',
      },
      {
        text: 'Nombre de tu líder',
        type: 'input',
        id: 'personal_leader_name',
      },
      {
        text: 'Teléfono de tu líder',
        type: 'input',
        kind: 'number',
        id: 'personal_leader_phone',
      },
      {
        text: 'Estado civil',
        type: 'select',
        options: ['Casado/a', 'Soltero/a', 'Union Libre', 'Viudo/a', 'Separado/a'],
        id: 'personal_civil_status',
      },
      {
        type: 'habeasData',
      },
      {
        type: 'prevButton',
      },
      {
        type: 'send',
      },
    ],
  ],
  Transformacion_Empresarial: [
    [
      {
        text: 'Facilitador seminario Transformación Empresarial',
        type: 'title',
      },
      {
        text: '¿Fuiste facilitador en el ciclo pasado?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'info_facilitator_questions_0',
      },
      {
        type: 'nextButton',
      },
    ],
    [
      {
        text: 'Facilitadores en entrenamiento seminario Transformación Empresarial',
        type: 'title',
      },
      newLeadersRequirementLists.Transformacion_Empresarial,
      {
        text: 'Siendo así, te invitamos a diligenciar las siguientes preguntas para validar los requisitos y guiarte en el proceso.',
        type: 'text',
        textOnlyInQuestions: true,
        showWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Asistes activamente en un grupo de discipulado como mínimo hace 6 meses?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_0',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Tienes el aval del líder de tu grupo de discipulado?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_1',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Has realizado Crecer hasta el paso de vida?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_2',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Has culminado el seminario de Transformación empresarial o Más allá del Éxito?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_3',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Eres líder de un grupo de discipulado?',
        type: 'select',
        options: ['Si', 'No'],
        id: 'conditional_questions_4',
        conditionalRequiredWhen: SHOW_WHEN_PREVIOUS_FACILITATOR,
      },
      {
        type: 'nextButton',
      },
    ],
    [
      {
        text: 'Facilitador seminario Transformación Empresarial',
        type: 'title',
        textOnlyInQuestions: true,
      },
      {
        text: 'Preguntas personales',
        type: 'title',
      },
      ...wellnessQuestions(),
      {
        type: 'prevButton',
      },
      {
        type: 'nextButton',
      },
    ],
    [
      {
        text: 'Facilitador seminario Transformación Empresarial',
        type: 'title',
        textOnlyInQuestions: true,
      },
      {
        text: 'Llena tu información',
        type: 'form',
        textOnlyInQuestions: true,
      },
      {
        text: 'Nombre de tu líder',
        type: 'input',
        id: 'personal_leader_name',
      },
      {
        text: 'Teléfono de tu líder',
        type: 'input',
        kind: 'number',
        id: 'personal_leader_phone',
      },
      {
        text: 'Estado civil',
        type: 'select',
        options: ['Casado/a', 'Soltero/a', 'Union Libre', 'Viudo/a', 'Separado/a'],
        id: 'personal_civil_status',
      },
      {
        text: 'Nombre del facilitador que te acompañó en el seminario',
        type: 'input',
        id: 'info_facilitator_name',
        optionalWhen: { id: 'info_facilitator_questions_0', value: 'No' },
      },
      {
        text: 'Celular del facilitador que te acompañó en el seminario',
        type: 'input',
        kind: 'number',
        id: 'info_facilitator_phone',
        optionalWhen: { id: 'info_facilitator_questions_0', value: 'No' },
      },
      {
        type: 'habeasData',
      },
      {
        type: 'prevButton',
      },
      {
        type: 'send',
      },
    ],
  ],
  Escuela_de_Heroes: [
    [
      {
        text: 'Facilitador seminario Escuela de Heroes',
        type: 'title',
      },
      {
        text: '¿Fuiste facilitador en el ciclo pasado?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'info_facilitator_questions_0',
      },
      {
        type: 'nextButton',
      },
    ],
    [
      {
        text: 'Facilitadores en entrenamiento seminario Escuela de Heroes',
        type: 'title',
      },
      newLeadersRequirementLists.Escuela_de_Heroes,
      {
        text: 'Siendo así, te invitamos a diligenciar las siguientes preguntas para validar los requisitos y guiarte en el proceso.',
        type: 'text',
        textOnlyInQuestions: true,
        showWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Asistes activamente en un grupo de discipulado como mínimo hace 6 meses?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_0',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Tienes el aval del líder de tu grupo de discipulado?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_1',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Has realizado Crecer hasta el paso de vida?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_2',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Has culminado el seminario de Escuela de Heroes?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_3',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Eres líder de un grupo de discipulado?',
        type: 'select',
        options: ['Si', 'No'],
        id: 'conditional_questions_4',
        conditionalRequiredWhen: SHOW_WHEN_PREVIOUS_FACILITATOR,
      },
      {
        type: 'nextButton',
      },
    ],
    [
      {
        text: 'Facilitador seminario Escuela de Heroes',
        type: 'title',
        textOnlyInQuestions: true,
      },
      {
        text: 'Preguntas personales',
        type: 'title',
      },
      ...wellnessQuestions(),
      {
        type: 'prevButton',
      },
      {
        type: 'nextButton',
      },
    ],
    [
      {
        text: 'Facilitador seminario Escuela de Heroes',
        type: 'title',
        textOnlyInQuestions: true,
      },
      {
        text: 'Llena tu información',
        type: 'form',
        textOnlyInQuestions: true,
      },
      {
        text: 'Nombre de tu líder',
        type: 'input',
        id: 'personal_leader_name',
      },
      {
        text: 'Teléfono de tu líder',
        type: 'input',
        kind: 'number',
        id: 'personal_leader_phone',
      },
      {
        text: 'Estado civil',
        type: 'select',
        options: ['Casado/a', 'Soltero/a', 'Union Libre', 'Viudo/a', 'Separado/a'],
        id: 'personal_civil_status',
      },
      {
        text: 'Nombre del facilitador que te acompañó en el seminario',
        type: 'input',
        id: 'info_facilitator_name',
        optionalWhen: { id: 'info_facilitator_questions_0', value: 'No' },
      },
      {
        text: 'Celular del facilitador que te acompañó en el seminario',
        type: 'input',
        kind: 'number',
        id: 'info_facilitator_phone',
        optionalWhen: { id: 'info_facilitator_questions_0', value: 'No' },
      },
      {
        type: 'habeasData',
      },
      {
        type: 'prevButton',
      },
      {
        type: 'send',
      },
    ],
  ],
  Ruta_128: [
    [
      {
        text: 'Facilitador seminario Ruta 128',
        type: 'title',
      },
      {
        text: '¿Fuiste facilitador en el ciclo pasado?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'info_facilitator_questions_0',
      },
      {
        type: 'nextButton',
      },
    ],
    [
      {
        text: 'Facilitadores en entrenamiento seminario Ruta 128',
        type: 'title',
      },
      newLeadersRequirementLists.Ruta_128,
      {
        text: 'Siendo así, te invitamos a diligenciar las siguientes preguntas para validar los requisitos y guiarte en el proceso.',
        type: 'text',
        textOnlyInQuestions: true,
        showWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Asistes activamente en un grupo de discipulado como mínimo hace 6 meses?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_0',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Tienes el aval del líder de tu grupo de discipulado?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_1',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Has realizado Crecer hasta el paso de vida?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_2',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Has culminado el seminario Ruta 128?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_3',
        showWhen: SHOW_WHEN_NEW_TRAINEE,
        conditionalRequiredWhen: SHOW_WHEN_NEW_TRAINEE,
      },
      {
        text: '¿Eres líder de un grupo de discipulado?',
        type: 'select',
        options: ['Si', 'No'],
        id: 'conditional_questions_4',
        conditionalRequiredWhen: SHOW_WHEN_PREVIOUS_FACILITATOR,
      },
      {
        type: 'nextButton',
      },
    ],
    [
      {
        text: 'Facilitador seminario Ruta 128',
        type: 'title',
        textOnlyInQuestions: true,
      },
      {
        text: 'Preguntas personales',
        type: 'title',
      },
      ...wellnessQuestions(),
      {
        type: 'prevButton',
      },
      {
        type: 'nextButton',
      },
    ],
    [
      {
        text: 'Facilitador seminario Ruta 128',
        type: 'title',
        textOnlyInQuestions: true,
      },
      {
        text: 'Llena tu información',
        type: 'form',
        textOnlyInQuestions: true,
      },
      {
        text: 'Nombre de tu líder',
        type: 'input',
        id: 'personal_leader_name',
      },
      {
        text: 'Teléfono de tu líder',
        type: 'input',
        kind: 'number',
        id: 'personal_leader_phone',
      },
      {
        text: 'Estado civil',
        type: 'select',
        options: ['Casado/a', 'Soltero/a', 'Union Libre', 'Viudo/a', 'Separado/a'],
        id: 'personal_civil_status',
      },
      {
        text: 'Nombre del facilitador que te acompañó en el seminario',
        type: 'input',
        id: 'info_facilitator_name',
        optionalWhen: { id: 'info_facilitator_questions_0', value: 'No' },
      },
      {
        text: 'Celular del facilitador que te acompañó en el seminario',
        type: 'input',
        kind: 'number',
        id: 'info_facilitator_phone',
        optionalWhen: { id: 'info_facilitator_questions_0', value: 'No' },
      },
      {
        type: 'habeasData',
      },
      {
        type: 'prevButton',
      },
      {
        type: 'send',
      },
    ],
  ],
  Entrenador_de_Equipo: [
    [
      {
        text: 'Entrenador de un Equipo de lideres',
        type: 'title',
      },
      newLeadersRequirementLists.Entrenador_de_Equipo,
      {
        text: 'Siendo así, te invitamos a diligenciar las siguientes preguntas para validar los requisitos y guiarte en el proceso.',
        type: 'text',
        textOnlyInQuestions: true,
      },
      {
        text: '¿Tienes como mínimo (1) un líder en tu grupo y ese líder lleva discipulando un grupo entre 4 y 6 meses?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_0',
      },
      {
        text: '¿Ya realizaste todos los procesos de crecer?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_1',
      },
      {
        text: '¿Te sientes conectado con la visión de comunidad de formar a otros discipuladores?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_2',
      },
      {
        text: '¿Tienes el aval de tu líder?',
        type: 'select',
        options: ['Sí', 'No'],
        id: 'conditional_questions_3',
      },
      {
        type: 'nextButton',
      },
    ],
    [
      {
        text: 'Entrenador de un Equipo de lideres',
        type: 'title',
        textOnlyInQuestions: true,
      },
      {
        text: 'Llena tu información',
        type: 'form',
        textOnlyInQuestions: true,
      },
      {
        text: 'Nombre de tu líder',
        type: 'input',
        id: 'personal_leader_name',
      },
      {
        text: 'Teléfono de tu líder',
        type: 'input',
        kind: 'number',
        id: 'personal_leader_phone',
      },
      {
        text: 'Estado civil',
        type: 'select',
        options: ['Casado/a', 'Soltero/a', 'Union Libre', 'Viudo/a', 'Separado/a'],
        id: 'personal_civil_status',
      },
      {
        type: 'prevButton',
      },
      {
        type: 'nextButton',
      },
    ],
    [
      {
        text: 'Entrenador de un Equipo de lideres',
        type: 'title',
        textOnlyInQuestions: true,
      },
      newLeadersRequirementLists.Entrenador_de_Equipo,
      {
        text: 'Si cumples con estos puntos, debes de esperar la capacitación para entrenadores nuevos; el área de discipulado se estará comunicando contigo para poder asistir.',
        type: 'text',
        textOnlyInQuestions: true,
      },
      {
        type: 'habeasData',
      },
      {
        type: 'prevButton',
      },
      {
        type: 'send',
      },
    ],
  ],
};
export const kindOfGroups = [
  {
    text: 'Grupo de Discipulado',
    value: 'Grupo_de_Discipulado',
  },
  {
    text: 'Entrenador de Equipo de Lideres',
    value: 'Entrenador_de_Equipo',
  },
];
export const kindOfSeminaries = [
  {
    text: 'Seminario de Proyecto Matrimonio',
    value: 'Couple_Seminaries',
  },
  {
    text: 'Seminario Para Siempre',
    value: 'Couple_Seminaries',
  },
  {
    text: 'Seminario de Relaciones Sanas',
    value: 'Relaciones_Sanas',
  },
  {
    text: 'Seminario Transformación Empresarial',
    value: 'Transformacion_Empresarial',
  },
  {
    text: 'Seminario Escuela de Héroes',
    value: 'Escuela_de_Heroes',
  },
  {
    text: 'Seminario Ruta 128',
    value: 'Ruta_128',
  },
];
export const formQuestionList = [
  {
    text: 'Solicitud para ser líder de grupo, entrenador de equipo o Facilitador de seminario',
    type: 'title',
  },
  {
    text: 'Gracias por responder al llamado de ser un líder o facilitador en Comunidad.',
    type: 'text',
  },
  {
    text: 'Por favor elige la opción de acuerdo a tu solicitud.',
    type: 'text',
  },
  {
    text: 'Quieres ser líder de un grupo o entrenador de un equipo:',
    type: 'select',
    optionsObjects: kindOfGroups,
    id: 'formQuestion',
  },
  {
    text: 'Quieres ser facilitador de un seminario:',
    type: 'select',
    optionsObjects: kindOfSeminaries,
    id: 'formQuestion',
  },
];
export const endQuestionary = (formQuestion, validation, inputs = {}) => [
  {
    text: 'Solicitud para ser líder de grupo, entrenador de equipo o Facilitador de seminario',
    type: 'title',
  },
  ...(formQuestion === 'Grupo_de_Discipulado'
    ? validation
      ? [
          {
            text: '¡Gracias por responder al llamado de ir y hacer discípulos! Te invitamos a esperar la entrevista realizada por el equipo de discipulado y luego recibir la capacitación para líderes nuevos.',
            type: 'text',
          },
          {
            text: 'Recuerda No abrir grupo de discipulado sin tener todo el proceso completo.',
            type: 'text',
          },
          {
            text: '¡Muchas gracias!',
            type: 'text',
          },
        ]
      : [
          ...getMissingConditionsContent(formQuestion, inputs, newLeadersQuestions),
          {
            text: '¡Muchas gracias!',
            type: 'text',
          },
        ]
    : []),
  ...(formQuestion === 'Entrenador_de_Equipo'
    ? validation
      ? [
          {
            text: '¡Gracias por responder al llamado de formar discipuladores! Te invitamos a esperar la capacitación para nuevos entrenadores. El equipo de discipulado se pondrá en contacto.',
            type: 'text',
          },
        ]
      : [
          {
            text: '¡Gracias por responder al llamado de formar discipuladores!',
            type: 'text',
          },
          ...getMissingConditionsContent(formQuestion, inputs, newLeadersQuestions),
          newLeadersRequirementLists?.Entrenador_de_Equipo,
          {
            text: '¡Muchas gracias!',
            type: 'text',
          },
        ]
    : []),
  ...(formQuestion === 'Couple_Seminaries' ||
  formQuestion === 'Relaciones_Sanas' ||
  formQuestion === 'Transformacion_Empresarial' ||
  formQuestion === 'Escuela_de_Heroes' ||
  formQuestion === 'Ruta_128'
    ? validation
      ? [
          {
            text: 'Si cumplen con todos los puntos, los estaremos contactando luego de validar la información. Si te falta alguno de los puntos, te invitamos a realizarlo para que en el próximo semestre puedan continuar con el proceso.',
            type: 'text',
          },
          {
            text: '¡Muchas gracias!',
            type: 'text',
          },
        ]
      : [
          ...getMissingConditionsContent(formQuestion, inputs, newLeadersQuestions),
          {
            text: '¡Muchas gracias!',
            type: 'text',
          },
        ]
    : []),
];
